import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { CalendarClock } from "lucide-react";

const TIMES = Array.from({ length: 96 }, (_, i) => `${String(Math.floor(i / 4)).padStart(2, "0")}:${String((i % 4) * 15).padStart(2, "0")}`);

export const fmtWhen = (iso) => new Date(iso).toLocaleString("de-DE", { weekday: "short", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

export function scheduleIso(s) {
  return s.on && s.date && s.time ? new Date(`${s.date}T${s.time}:00`).toISOString() : null;
}

export function SchedulePicker({ value, onChange }) {
  const now = new Date();
  const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
  const iso = scheduleIso(value);
  const past = iso && new Date(iso) <= new Date();
  return (
    <div className="rounded-lg border border-slate-200 bg-slate-50 px-3 py-2.5 text-sm" data-testid="schedule-picker">
      <label className="flex items-center gap-2 font-medium text-slate-700 cursor-pointer">
        <input type="checkbox" checked={value.on} onChange={(e) => onChange({ ...value, on: e.target.checked })} data-testid="schedule-toggle" />
        <CalendarClock size={15} /> Zeitversetzt senden
      </label>
      {value.on && (
        <div className="flex flex-wrap items-end gap-3 mt-2">
          <div><Label className="text-xs">Datum</Label><Input type="date" min={today} value={value.date} onChange={(e) => onChange({ ...value, date: e.target.value })} className="mt-1 w-44 bg-white" data-testid="schedule-date" /></div>
          <div><Label className="text-xs">Uhrzeit</Label>
            <select value={value.time} onChange={(e) => onChange({ ...value, time: e.target.value })} className="mt-1 h-9 rounded-md border border-input bg-white px-2 text-sm" data-testid="schedule-time">
              {TIMES.map((t) => <option key={t} value={t}>{t} Uhr</option>)}
            </select>
          </div>
          <p className={`text-xs ${past ? "text-red-600" : "text-slate-500"}`} data-testid="schedule-hint">{past ? "Der Zeitpunkt liegt in der Vergangenheit." : "Der Versand startet zum gewählten Zeitpunkt (spätestens 15 Minuten danach). Platzhalter werden erst beim Versand befüllt."}</p>
        </div>
      )}
    </div>
  );
}

export const emptySchedule = () => ({ on: false, date: "", time: "09:00" });
